'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIBadge from 'UIComponents/badge/UIBadge';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import IsEnabledForEmailV3RenderingToggle from 'DesignEditorsUI/components/shared/controls/IsEnabledForEmailV3RenderingToggle';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';

const toolbarI18nKey = key => `DesignEditorsUI.customWidgetEditor.toolbar.${key}`;

function makeMapStateToProps() {
  const getCustomWidgetBuffer = customWidgetBuffersSelectors.makeGetCustomWidgetBuffer();
  const getIsEmailOrAnyType = customWidgetBuffersSelectors.makeGetIsEmailOrAnyType();
  return (state, props) => {
    const customWidgetBuffer = getCustomWidgetBuffer(state, props);
    return {
      isBufferLoaded: !!customWidgetBuffer,
      isEnabledForEmailV3Rendering: !!(customWidgetBuffer && customWidgetBuffer.isEnabledForEmailV3Rendering),
      isEmailOrAnyType: getIsEmailOrAnyType(state, props)
    };
  };
}

const mapDispatchToProps = {
  setIsSelectingIcon: CustomWidgetEditorOptionsActions.setIsSelectingIcon
};

class EmailV3RenderingToggle extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onIsEnabledForEmailV3RenderingToggleChange = isEnabledForEmailV3Rendering => {
      this.props.updateCustomWidget({
        isEnabledForEmailV3Rendering
      });
    };
  }

  render() {
    if (!this.props.isEmailOrAnyType) {
      return null;
    }

    return /*#__PURE__*/_jsx(IsEnabledForEmailV3RenderingToggle, {
      disabled: !this.props.isBufferLoaded || this.props.isReadOnly,
      checked: !!this.props.isEnabledForEmailV3Rendering,
      onChange: this.onIsEnabledForEmailV3RenderingToggleChange,
      toggleLabel: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-right-2",
          message: toolbarI18nKey('isEnabledForEmailV3Rendering.label')
        }), /*#__PURE__*/_jsx(UIBadge, {
          use: "beta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: toolbarI18nKey('isEnabledForEmailV3Rendering.beta')
          })
        })]
      }),
      tooltipTitle: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: toolbarI18nKey('isEnabledForEmailV3Rendering.tooltipTitle_jsx'),
          elements: {
            KnowledgeBaseButton: () => /*#__PURE__*/_jsx(KnowledgeBaseButton, {
              url: "https://knowledge.hubspot.com/email/create-programmable-emails"
            })
          }
        })
      }),
      fileId: this.props.customWidgetId
    });
  }

}

EmailV3RenderingToggle.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  isEmailOrAnyType: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  updateCustomWidget: PropTypes.func.isRequired,
  isBufferLoaded: PropTypes.bool.isRequired,
  isEnabledForEmailV3Rendering: PropTypes.bool.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(EmailV3RenderingToggle);